import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, AppConfig } from '../../config/app-config';

@Injectable()
export class ApiKeyInterceptor implements HttpInterceptor {
  constructor(@Inject(APP_CONFIG) private config: AppConfig) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Skip adding API key for OIDC-related requests (e.g., requests to Keycloak)
    if (this.isOidcRequest(req)) {
      return next.handle(req); // No need to modify the request
    }

    // Add API key if available and request is not OIDC-related
    const apiKey = this.getApiKey();
    if (apiKey) {
      req = req.clone({
        setHeaders: { 'X-Api-Key': apiKey },
      });
    }

    return next.handle(req);
  }

  private getApiKey() {
    return this.config.managementApiKey; // Get API Key from the config
  }

  // Check if the request is related to OIDC (Keycloak or similar)
  private isOidcRequest(req: HttpRequest<any>): boolean {
    const oidcBaseUrl = 'https://keycloak.internal.buildspaceproject.eu'; // Your Keycloak base URL
    let baseUrl: string

    try {
        baseUrl = new URL(req.url).origin; // Extract base URL safely
    } catch (error) {
        return false; // Return false if the URL is invalid
    }   
    console.log(oidcBaseUrl, baseUrl, oidcBaseUrl == baseUrl )
    // Return true if the base URL matches the OIDC base URL
    return baseUrl === oidcBaseUrl;
  }
}
